"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _tableCompare = _interopRequireDefault(require("../styles/table-compare.css"));

var selectUpdateEvent = function selectUpdateEvent(params) {
  var event = params.event,
      models = params.models,
      updateSelected = params.updateSelected,
      order = params.order;
  var selectedCode = event.target.value; // eslint-disable-next-line guard-for-in

  for (var index in models) {
    var model = models[index];

    if (selectedCode === model.code) {
      model.order = order;
      updateSelected(model);
      break;
    }
  }
};

var CompareSelectBoxes = function CompareSelectBoxes(_ref) {
  var models = _ref.models,
      theme = _ref.theme,
      order = _ref.order,
      selectedValue = _ref.selectedValue,
      updateSelected = _ref.updateSelected;
  return /*#__PURE__*/_react["default"].createElement("select", {
    className: theme.customSelect + " " + _tableCompare["default"].dropDownSelect,
    value: selectedValue,
    onChange: function onChange(event) {
      return selectUpdateEvent({
        event: event,
        models: models,
        updateSelected: updateSelected,
        order: order
      });
    }
  }, models.map(function (model) {
    if (model.selected) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        disabled: true,
        key: model.code,
        value: model.code
      }, model.name);
    }

    return /*#__PURE__*/_react["default"].createElement("option", {
      key: model.code,
      value: model.code
    }, model.name);
  }));
};

var _default = CompareSelectBoxes;
exports["default"] = _default;